import { Component } from '@angular/core';
export class ConfirmationConfirmedComponent {
constructor() {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'confirmation-confirmed',
  template: `
    <div class="tnk-card tnk-card--primary">
      <div class="tnk-card__header">
        <span class="tnk-font--lead">Formulir konfirmasi telah terkirim</span>
      </div>
      <div class="tnk-card__body">
        <div class="tnk-padding">
          <p class="tnk-confirmation--p">
            Pantau terus aplikasi Tunaiku untuk mengikuti perkembangan pengajuan
            pinjaman Anda.
          </p>
          <ul class="tnk-ul">
            <li class="tnk-li">Proses kurang dari 24 jam.</li>
            <li class="tnk-li">
              Jika terdapat kendala, paling lama akan diproses dalam 1-3 hari kerja.
            </li>
            <li class="tnk-li">
              Pastikan handphone Anda selalu
              <strong>AKTIF</strong>
              .
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="tnk-card tnk-card--primary">
      <div class="tnk-card__header">
        <span class="tnk-font--lead">Persiapkan dokumen Anda!</span>
      </div>
      <div class="tnk-card__body">
        <div class="tnk-padding">
          <p class="tnk-confirmation--p">
            Tahapan selanjutnya adalah tanda tangan kontrak, Sebelum bertemu tim
            kami, siapkan beberapa dokumen sebagai berikut:
          </p>
          <ul class="tnk-ul">
            <li class="tnk-li">KTP/Resi (Asli)</li>
            <li class="tnk-li">
              Kartu Keluarga (Asli)
            </li>
            <li class="tnk-li">
              Buku Tabungan (Asli)
            </li>
          </ul>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .tnk-card {
      background: #fdfdfd;
      border-left: 5px solid #ffc412;
      border-radius: 5px;
      color: #535353;
      margin-bottom: 15px; }
      .tnk-card__nav {
        margin: 15px 0; }
      .tnk-card__header {
        border-bottom: 1px solid #e1e1e1;
        padding: 15px;
        -ms-flex-flow: wrap;
            flex-flow: wrap; }
        .tnk-card__header h1 {
          font-size: 16px;
          margin: 0;
          width: 100%; }
        .tnk-card__header small {
          font-size: 12px;
          color: #9b9b9b;
          width: 100%; }
      .tnk-card__body {
        padding: 10px 0; }
        .tnk-card__body .exampling-container__item {
          background: #f4f4f4;
          border-radius: 10px;
          padding: 10px;
          margin: 5px 0 15px 0;
          text-align: center; }
          .tnk-card__body .exampling-container__item-row {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
                -ms-flex-direction: row;
                    flex-direction: row;
            justify-items: center;
            -webkit-box-pack: center;
                -ms-flex-pack: center;
                    justify-content: center;
            margin: 0 auto; }
          .tnk-card__body .exampling-container__item .img-padding {
            padding: 4px; }
          .tnk-card__body .exampling-container__item .exampling-img {
            margin: 5px 0 10px 0; }
            .tnk-card__body .exampling-container__item .exampling-img.text-red {
              color: #ff0000; }
            .tnk-card__body .exampling-container__item .exampling-img.text-green {
              color: #80bd01; }
            .tnk-card__body .exampling-container__item .exampling-img img {
              margin: 0 auto;
              height: 100px; }
            .tnk-card__body .exampling-container__item .exampling-img h4 {
              margin: 5px 0;
              font-size: 12px;
              font-weight: bolder; }
          .tnk-card__body .exampling-container__item h2 {
            font-size: 14px;
            margin: 0 0 10px 0;
            text-align: center;
            font-weight: bolder; }
          .tnk-card__body .exampling-container__item small {
            font-size: 12px;
            margin: 5px 0; }
        .tnk-card__body .exampling-container__preview img {
          max-width: 150px; }
        .tnk-card__body .exampling-container__error p {
          color: #ff0000;
          padding-bottom: 10px; }
        .tnk-card__body .cancel-content form div {
          margin: 15px 0; }
        .tnk-card__body .form-group p {
          font-size: 12px;
          margin: -7px 0 4px 0; }
        .tnk-card__body h1 {
          margin: 0;
          font-size: 16px;
          font-weight: bolder;
          line-height: 21px; }
        .tnk-card__body h4 {
          margin: 0;
          font-size: 12px; }
        .tnk-card__body ul {
          padding: 0;
          margin: 0; }
          .tnk-card__body ul li:not(.tnk-li) {
            list-style-type: none; }
        .tnk-card__body ul.tnk-ul {
          margin-left: 15px; }
        .tnk-card__body strong {
          font-weight: bolder; }
        .tnk-card__body p {
          font-size: 14px;
          line-height: 21px; }
        .tnk-card__body p.tnk-confirmation--p {
          font-size: 16px; }
        .tnk-card__body small {
          font-size: 12px; }

    .p-t {
      padding-top: 10px; }

    .p-b {
      padding-bottom: 10px; }

    .p-y {
      padding: 5px 0px; }

    .p-x {
      padding: 0px 5px; }

    .tnk-button__blue {
      width: 120px;
      color: #0087c6;
      background-color: #fdfdfd;
      border: 2.5px solid #0087c6;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__blue.active {
        color: #fdfdfd;
        background-color: #0087c6; }
      .tnk-button__blue.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__blue.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }

    .tnk-button__green {
      width: 120px;
      color: #80bd01;
      background-color: #fdfdfd;
      border: 2.5px solid #80bd01;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__green.active {
        color: #fdfdfd;
        background-color: #80bd01; }
      .tnk-button__green.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__green.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }
      .tnk-button__green.right {
        float: right; }

    .info-card {
      width: 100%;
      background-color: #fffcdb; }

    .info-card--mobile-view {
      display: none; }

    .info-card--desktop-view {
      display: inline; }

    @media (max-width: 768px) {
      .info-card--mobile-view {
        display: inline; }
      .info-card--desktop-view {
        display: none; } }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ConfirmationConfirmedComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationConfirmedComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationConfirmedComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
